import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type Policy from 'modules/payroll_bundle/store/models/Policy'

import { SHOW_BOOKKEEPER, SHOW_PAYROLL_POLICY } from './constants'

interface Props {
  stage: string
  bookkeeperIds: number[]
  onSubmitStage: () => void
  canCreatePolicy: boolean
  policy?: Policy | null
  disableCountryButton: boolean
}

const FormButton = ({
  stage,
  bookkeeperIds,
  onSubmitStage,
  canCreatePolicy,
  policy,
  disableCountryButton,
}: Props) => {
  const formButton = () => {
    switch (stage) {
      case SHOW_BOOKKEEPER:
        return (
          <>
            {bookkeeperIds.length ? (
              <Button submit>
                {i18n.t('app_store_v2.apps.payroll_bundle.install_modal.bookkeeper.submit')}
              </Button>
            ) : (
              <Button submit>
                {i18n.t(
                  'app_store_v2.apps.payroll_bundle.install_modal.bookkeeper.submit_nobookkeeper'
                )}
              </Button>
            )}
          </>
        )
      case SHOW_PAYROLL_POLICY:
        return (
          <Button onClick={onSubmitStage} disabled={!canCreatePolicy}>
            {policy?.attributes.id
              ? i18n.t('app_store_v2.apps.payroll_bundle.install_modal.payroll_policy.save_changes')
              : i18n.t(
                  'app_store_v2.apps.payroll_bundle.install_modal.payroll_policy.create_policy'
                )}
          </Button>
        )
      default:
        return (
          <Button onClick={onSubmitStage} disabled={disableCountryButton}>
            {i18n.t('app_store_v2.apps.payroll_bundle.install_modal.country.submit')}
          </Button>
        )
    }
  }

  return formButton()
}

export default FormButton
